(function () {
    var root = document.querySelector(".cart-screen");
    if (!root) return;

    var itemsWrap = root.querySelector("[data-cart-items]");
    var cartTotalEls = root.querySelectorAll("[data-cart-total]");
    var cartCountEls = root.querySelectorAll("[data-cart-count]");
    var checkoutButtons = root.querySelectorAll('button[name="checkout"], .cart-sticky-checkout__button');

    var stickyCheckout = root.querySelector("[data-sticky-checkout]");
    var stickySentinel = root.querySelector("[data-sticky-checkout-sentinel]");

    var shippingEstimator = root.querySelector("[data-shipping-estimator]");
    var shippingEstimatorToggle = root.querySelector("[data-shipping-estimator-toggle]");
    var shippingEstimatorForm = root.querySelector("[data-shipping-estimator-form]");
    var shippingPostcodeInput = root.querySelector("[data-shipping-postcode]");
    var shippingCustomerNameInput = root.querySelector("[data-shipping-customer-name]");
    var shippingEstimatorButton = root.querySelector("[data-shipping-estimator-button]");
    var shippingEstimatorStatus = root.querySelector("[data-shipping-estimator-status]");
    var shippingEstimatorResults = root.querySelector("[data-shipping-estimator-results]");

    var pendingLineUpdates = new Set();
    var stockLimitOverrides = new Map();
    var stockLimitsByVariant = {};

    var stockLimitsElement = root.querySelector("[data-cart-stock-limits]");

    if (stockLimitsElement) {
        try {
            var parsedStockLimits = JSON.parse(stockLimitsElement.textContent || "[]");

            parsedStockLimits.forEach(function (entry) {
                if (!entry || entry.variant_id == null) return;

                var limit = Number(entry.limit);

                if (Number.isFinite(limit)) {
                    stockLimitsByVariant[String(entry.variant_id)] = Math.max(0, limit);
                }
            });
        } catch (error) {
            console.error("Unable to read cart stock limits.", error);
        }
    }

    var SHIPPING_ESTIMATE_ENDPOINT = window.FREIGHTMATE_ESTIMATE_ENDPOINT || root.getAttribute("data-freightmate-estimate-endpoint") || "/apps/freightmate-v3/cart-estimate";
    var TRACK_ENDPOINT = window.FREIGHTMATE_TRACK_ENDPOINT || root.getAttribute("data-freightmate-track-endpoint") || "/apps/freightmate-v3/track";
    var lastShippingEstimatePostcode = "";
    var lastKnownCart = null;

    function endpointWithShop(endpoint) {
        var url;
        try {
            url = new URL(endpoint, window.location.origin);
        } catch (error) {
            return endpoint;
        }

        return url.toString();
    }


    document.addEventListener("DOMContentLoaded", function () {
        var cartSection = document.querySelector(".cart-screen");

        if (cartSection) {
            window.scrollTo({
                top: cartSection.offsetTop - 40,
                behavior: "instant"
            });
        }
    });

    function money(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
            return window.Shopify.formatMoney(cents);
        }

        return "$" + (Number(cents || 0) / 100).toFixed(2);
    }

    function escapeHtml(str) {
        return String(str == null ? "" : str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    function getItemElByLine(line) {
        return root.querySelector('[data-cart-item][data-line="' + line + '"]');
    }

    function setupStickyCheckout() {
        if (!stickyCheckout) return;

        function isMobileLayout() {
            return window.matchMedia("(max-width: 989px)").matches;
        }

        function updateStickyState() {
            if (isMobileLayout()) {
                stickyCheckout.classList.add("is-visible");
                return;
            }

            if (!stickySentinel) {
                stickyCheckout.classList.remove("is-visible");
                return;
            }

            var rect = stickySentinel.getBoundingClientRect();
            var shouldShow = rect.bottom < 0;

            stickyCheckout.classList.toggle("is-visible", shouldShow);
        }

        updateStickyState();

        window.addEventListener("scroll", updateStickyState, { passive: true });
        window.addEventListener("resize", updateStickyState);
    }

    function getMaxQty(item, cart) {
        var possibleLimits = [];
        var currentQty = parseInt(item && item.quantity, 10) || 0;

        if (
            item &&
            item.quantity_rule &&
            typeof item.quantity_rule.max === "number" &&
            item.quantity_rule.max > 0
        ) {
            possibleLimits.push(item.quantity_rule.max);
        }

        var variantId = item && item.variant_id != null
            ? String(item.variant_id)
            : "";

        var inventoryLimit = stockLimitsByVariant[variantId];

        if (Number.isFinite(inventoryLimit)) {
            var otherLineQuantity = (cart.items || []).reduce(function (total, otherItem) {
                if (!otherItem) return total;

                var sameVariant = String(otherItem.variant_id) === variantId;
                var sameLine = otherItem.key === item.key;

                if (sameVariant && !sameLine) {
                    return total + (parseInt(otherItem.quantity, 10) || 0);
                }

                return total;
            }, 0);

            possibleLimits.push(Math.max(0, inventoryLimit - otherLineQuantity));
        }

        if (item && item.key && stockLimitOverrides.has(item.key)) {
            possibleLimits.push(stockLimitOverrides.get(item.key));
        }

        if (!possibleLimits.length) {
            return null;
        }

        /*
         * Do not force an existing line below its currently confirmed quantity.
         * This still prevents the customer from increasing it any further.
         */
        return Math.max(currentQty, Math.min.apply(Math, possibleLimits));
    }

    function renderProperties(properties) {
        if (!properties || typeof properties !== "object") return "";

        var html = Object.keys(properties)
            .filter(function (key) {
                return properties[key] != null && properties[key] !== "" && key.charAt(0) !== "_";
            })
            .map(function (key) {
                return '<div class="cart-item__property"><strong>' + escapeHtml(key) + ":</strong> " + escapeHtml(properties[key]) + "</div>";
            })
            .join("");

        if (!html) return "";
        return '<div class="cart-item__properties">' + html + "</div>";
    }

    function buildImageUrl(url, width) {
        if (!url) return "";

        if (url.indexOf("?") === -1) {
            return url + "?width=" + width;
        }

        return url + "&width=" + width;
    }

    function renderCartItems(cart) {
        if (!itemsWrap) return;

        if (!cart.items || !cart.items.length) {
            window.location.reload();
            return;
        }

        itemsWrap.innerHTML = cart.items.map(function (item, index) {
            var line = index + 1;
            var qty = parseInt(item.quantity, 10) || 0;
            var maxQty = getMaxQty(item, cart);

            var minusDisabled = qty <= 1 ? " disabled" : "";
            var plusDisabled = (typeof maxQty === "number" && qty >= maxQty) ? " disabled" : "";
            var maxAttr = typeof maxQty === "number" ? ' data-max-qty="' + escapeHtml(maxQty) + '"' : "";

            var variantTitle = item.variant_title && item.variant_title !== "Default Title"
                ? '<div class="cart-item__variant">' + escapeHtml(item.variant_title) + "</div>"
                : "";

            var imageHtml = item.featured_image && item.featured_image.url
                ? '<a href="' + escapeHtml(item.url) + '" class="cart-item__image-link"><img class="cart-item__image" src="' + escapeHtml(buildImageUrl(item.featured_image.url, 320)) + '" alt="' + escapeHtml(item.product_title || "") + '" loading="lazy" width="320" height="320"></a>'
                : '<div class="cart-item__image cart-item__image--placeholder"></div>';

            return ''
                + '<article class="cart-item" data-cart-item data-key="' + escapeHtml(item.key) + '" data-variant-id="' + escapeHtml(item.variant_id) + '" data-current-qty="' + escapeHtml(qty) + '" data-line="' + line + '"' + maxAttr + '>'
                + '  <div class="cart-item__media">' + imageHtml + '</div>'
                + '  <div class="cart-item__content">'
                + '    <div class="cart-item__top">'
                + '      <div>'
                + '        <h2 class="cart-item__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></h2>'
                +          variantTitle
                + '      </div>'
                + '      <button type="button" class="cart-item__remove" data-remove-item data-line="' + line + '" aria-label="Remove ' + escapeHtml(item.product_title || "item") + '">✕</button>'
                + '    </div>'
                + '    <div class="cart-item__bottom">'
                + '      <div class="cart-item__quantity">'
                + '        <span class="cart-item__label">Quantity</span>'
                + '        <div class="cart-qty" data-qty-wrap>'
                + '          <button type="button" class="cart-qty__button" data-qty-minus data-line="' + line + '" aria-label="Decrease quantity"' + minusDisabled + '>−</button>'
                + '          <input class="cart-qty__input" type="number" min="1" step="1" inputmode="numeric" value="' + escapeHtml(item.quantity) + '" data-qty-input data-line="' + line + '"' + (typeof maxQty === "number" ? ' max="' + escapeHtml(maxQty) + '"' : '') + ' aria-label="Quantity">'
                + '          <button type="button" class="cart-qty__button" data-qty-plus data-line="' + line + '" aria-label="Increase quantity"' + plusDisabled + '>+</button>'
                + '        </div>'
                + '      </div>'
                + '      <div class="cart-item__prices" data-line-price-wrap>'
                + '        <div class="cart-item__price-loading" data-line-loading hidden>'
                + '          <span class="cart-item__price-spinner" aria-hidden="true"></span>'
                + '        </div>'
                + '        <div class="cart-item__unit-price">' + money(item.final_price) + (item.quantity > 1 ? '<span class="cart-item__unit-price-note">each</span>' : '') + '</div>'
                + '        <div class="cart-item__line-price">' + money(item.final_line_price) + '</div>'
                + '      </div>'
                + '    </div>'
                +      renderProperties(item.properties)
                + '  </div>'
                + '</article>';
        }).join("");

        syncAllQuantityControls();
    }

    function updateSummary(cart) {
        cartTotalEls.forEach(function (el) {
            el.innerHTML = money(cart.total_price || 0);
        });

        cartCountEls.forEach(function (el) {
            el.textContent = String(cart.item_count || 0);
        });
    }

    function setCheckoutButtonState() {
        var busy = pendingLineUpdates.size > 0;

        checkoutButtons.forEach(function (button) {
            button.disabled = busy;
            button.classList.toggle("is-loading", busy);

            var text = button.querySelector(".cart-summary__checkout-button-text");
            if (text) {
                text.textContent = busy ? "Updating cart..." : "Checkout";
            }
        });
    }

    function syncLineQtyControls(line) {
        var itemEl = getItemElByLine(line);
        if (!itemEl) return;

        var minusBtn = itemEl.querySelector("[data-qty-minus]");
        var plusBtn = itemEl.querySelector("[data-qty-plus]");
        var input = itemEl.querySelector("[data-qty-input]");

        if (!input) return;

        var qty = parseInt(input.value, 10);

        if (!Number.isFinite(qty) || qty < 1) {
            qty = 1;
        }

        var maxQtyAttr = itemEl.getAttribute("data-max-qty");
        var maxQty = maxQtyAttr ? parseInt(maxQtyAttr, 10) : NaN;
        var isInputDisabled = !!input.disabled;
        var atStockLimit = !Number.isNaN(maxQty) && qty >= maxQty;

        if (minusBtn) {
            minusBtn.disabled = isInputDisabled || qty <= 1;
        }

        if (plusBtn) {
            plusBtn.disabled = isInputDisabled || atStockLimit;
        }
    }

    function syncAllQuantityControls() {
        var itemEls = root.querySelectorAll("[data-cart-item]");

        itemEls.forEach(function (itemEl) {
            var line = itemEl.getAttribute("data-line");
            if (line) syncLineQtyControls(line);
        });
    }

    function setLineLoading(line, loading) {
        var itemEl = getItemElByLine(line);
        if (!itemEl) return;

        var loadingEl = itemEl.querySelector("[data-line-loading]");
        var minusBtn = itemEl.querySelector("[data-qty-minus]");
        var plusBtn = itemEl.querySelector("[data-qty-plus]");
        var input = itemEl.querySelector("[data-qty-input]");
        var removeBtn = itemEl.querySelector("[data-remove-item]");

        if (loadingEl) {
            loadingEl.hidden = !loading;
        }

        if (input) input.disabled = loading;
        if (removeBtn) removeBtn.disabled = loading;

        itemEl.classList.toggle("is-updating", loading);

        if (minusBtn) minusBtn.disabled = loading || minusBtn.disabled;
        if (plusBtn) plusBtn.disabled = loading || plusBtn.disabled;

        syncLineQtyControls(line);
    }

    async function fetchCart() {
        var response = await fetch(window.Shopify.routes.root + "cart.js", {
            method: "GET",
            headers: { Accept: "application/json" }
        });

        if (!response.ok) {
            throw new Error("We could not load your cart. Please refresh and try again.");
        }

        var data = await response.json();
        lastKnownCart = data;
        return data;
    }

    async function changeLineByLine(line, quantity) {
        var payload = {
            line: Number(line),
            quantity: Number(quantity)
        };

        var response = await fetch(window.Shopify.routes.root + "cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify(payload)
        });

        var data = await response.json();

        if (!response.ok) {
            var error = new Error(
                data.description ||
                data.message ||
                "We could not update your cart. Please try again."
            );

            error.status = response.status;
            throw error;
        }

        return data;
    }

    async function refreshCartUI() {
        var cart = await fetchCart();
        renderCartItems(cart);
        updateSummary(cart);
        setCheckoutButtonState();
        return cart;
    }

    function setShippingEstimatorLoading(isLoading) {
        if (!shippingEstimatorButton) return;

        shippingEstimatorButton.disabled = isLoading;
        shippingEstimatorButton.classList.toggle("is-loading", isLoading);

        var text = shippingEstimatorButton.querySelector(".cart-shipping-estimator__button-text");
        if (text) {
            text.textContent = isLoading ? "Estimating..." : "Estimate";
        }
    }

    function setShippingEstimatorStatus(message, isError) {
        if (!shippingEstimatorStatus) return;

        if (!message) {
            shippingEstimatorStatus.hidden = true;
            shippingEstimatorStatus.textContent = "";
            shippingEstimatorStatus.classList.remove("is-error");
            return;
        }

        shippingEstimatorStatus.hidden = false;
        shippingEstimatorStatus.textContent = message;
        shippingEstimatorStatus.classList.toggle("is-error", !!isError);
    }

    function clearShippingEstimatorResults() {
        if (shippingEstimatorResults) {
            shippingEstimatorResults.hidden = true;
            shippingEstimatorResults.innerHTML = "";
        }

        setShippingEstimatorStatus("", false);
    }

    function formatEstimatePrice(value) {
        var number = Number(value);

        if (!Number.isFinite(number)) {
            return "TBC";
        }

        if (number > 999) {
            return money(Math.round(number));
        }

        return "$" + number.toFixed(2);
    }

    function normaliseEstimateRates(data) {
        if (!data) return [];

        if (Array.isArray(data.rates)) return data.rates;
        if (Array.isArray(data.options)) return data.options;
        if (Array.isArray(data.shipping_rates)) return data.shipping_rates;

        return [];
    }

    function renderShippingEstimatorResults(data) {
        if (!shippingEstimatorResults) return;

        var rates = normaliseEstimateRates(data);

        if (!rates.length) {
            shippingEstimatorResults.hidden = true;
            shippingEstimatorResults.innerHTML = "";
            setShippingEstimatorStatus("No freight estimate was returned for this postcode. You can still continue to checkout for final freight options.", true);
            return;
        }

        var html = rates.map(function (rate) {
            var name = rate.name || rate.service_name || rate.title || "Shipping option";
            var description = rate.description || rate.service_description || rate.carrier || "";
            var price = rate.price;
            var totalPrice = rate.total_price;

            if (price == null && totalPrice != null) {
                price = totalPrice;
            }

            return ''
                + '<div class="cart-shipping-estimator__result">'
                + '  <div>'
                + '    <div class="cart-shipping-estimator__result-name">' + escapeHtml(name) + '</div>'
                +      (description ? '<div class="cart-shipping-estimator__result-description">' + escapeHtml(description) + '</div>' : '')
                + '  </div>'
                + '  <div class="cart-shipping-estimator__result-price">' + escapeHtml(formatEstimatePrice(price)) + '</div>'
                + '</div>';
        }).join("");

        shippingEstimatorResults.innerHTML = html;
        shippingEstimatorResults.hidden = false;

        setShippingEstimatorStatus("Estimated freight options for postcode " + lastShippingEstimatePostcode + ".", false);
    }

    function buildShippingEstimatePayload(cart, postcode) {
        var customerName = shippingCustomerNameInput ? shippingCustomerNameInput.value.trim() : "";

        return {
            postcode: postcode,
            customer_name: customerName || null,
            destination: {
                country: "AU",
                postal_code: postcode,
                name: customerName || null
            },
            cart: {
                item_count: cart.item_count,
                total_price: cart.total_price,
                currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "AUD",
                items: cart.items.map(function (item, index) {
                    return {
                        key: item.key,
                        line: index + 1,
                        product_id: item.product_id,
                        variant_id: item.variant_id,
                        sku: item.sku,
                        title: item.product_title,
                        variant_title: item.variant_title,
                        quantity: item.quantity,
                        grams: item.grams,
                        final_price: item.final_price,
                        final_line_price: item.final_line_price,
                        properties: item.properties || {}
                    };
                })
            }
        };
    }

    async function postEstimate(endpoint, payload) {
        var response = await fetch(endpointWithShop(endpoint), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify(payload)
        });

        var text = await response.text();
        var data = null;

        try {
            data = text ? JSON.parse(text) : null;
        } catch (error) {
            data = null;
        }

        if (!response.ok) {
            var msg = data && (data.description || data.message || data.error)
                ? data.description || data.message || data.error
                : "We could not estimate freight right now. Please try again or continue to checkout.";
            var err = new Error(msg);
            err.status = response.status;
            err.body = text;
            throw err;
        }

        return data || {};
    }

    async function estimateShippingForCart(postcode) {
        var cart = await fetchCart();
        var payload = buildShippingEstimatePayload(cart, postcode);
        return postEstimate(SHIPPING_ESTIMATE_ENDPOINT, payload);
    }

    function validatePostcode(value) {
        var postcode = String(value || "").replace(/\D/g, "").slice(0, 4);

        if (!/^\d{4}$/.test(postcode)) {
            return "";
        }

        return postcode;
    }

    async function updateQuantity(line, quantity) {
        if (pendingLineUpdates.has(line)) return;

        var itemBeforeUpdate = getItemElByLine(line);
        var itemKey = itemBeforeUpdate
            ? itemBeforeUpdate.getAttribute("data-key")
            : "";

        var currentQuantity = itemBeforeUpdate
            ? parseInt(itemBeforeUpdate.getAttribute("data-current-qty"), 10) || 0
            : 0;

        pendingLineUpdates.add(line);
        setLineLoading(line, true);
        setCheckoutButtonState();

        try {
            await changeLineByLine(line, quantity);

            if (Number(quantity) === 0 && itemKey) {
                stockLimitOverrides.delete(itemKey);
            }

            await refreshCartUI();
            clearShippingEstimatorResults();
        } catch (error) {
            console.error(error);

            var attemptedIncrease = Number(quantity) > currentQuantity;
            var inventoryError =
                attemptedIncrease &&
                (
                    error.status === 422 ||
                    /stock|inventory|available|maximum|can't add more|cannot add more/i.test(error.message || "")
                );

            if (inventoryError && itemKey) {
                /*
                 * Shopify rejected the next quantity, so the current confirmed
                 * quantity becomes the temporary maximum for this cart session.
                 */
                stockLimitOverrides.set(itemKey, currentQuantity);
            }

            await refreshCartUI();
        } finally {
            pendingLineUpdates.delete(line);
            setCheckoutButtonState();
        }
    }

    if (shippingEstimatorToggle && shippingEstimator) {
        var shippingEstimatorIcon = shippingEstimatorToggle.querySelector(
            ".cart-shipping-estimator__toggle-icon"
        );

        if (shippingEstimatorIcon) {
            shippingEstimatorIcon.textContent = "+";
        }

        shippingEstimatorToggle.addEventListener("click", function () {
            var isOpen = shippingEstimator.classList.toggle("is-open");

            shippingEstimatorToggle.setAttribute(
                "aria-expanded",
                isOpen ? "true" : "false"
            );

            /*
             * Keep the plus character unchanged. CSS rotates it by 45 degrees
             * while open so it appears as the same X used on the product page.
             */
            if (shippingEstimatorIcon) {
                shippingEstimatorIcon.textContent = "+";
            }
        });
    }

    if (shippingEstimatorForm) {
        shippingEstimatorForm.addEventListener("submit", async function (event) {
            event.preventDefault();

            var postcode = validatePostcode(shippingPostcodeInput ? shippingPostcodeInput.value : "");

            if (!postcode) {
                setShippingEstimatorStatus("Please enter a valid 4-digit Australian postcode.", true);

                if (shippingEstimatorResults) {
                    shippingEstimatorResults.hidden = true;
                    shippingEstimatorResults.innerHTML = "";
                }

                return;
            }

            if (shippingPostcodeInput) {
                shippingPostcodeInput.value = postcode;
            }

            lastShippingEstimatePostcode = postcode;

            setShippingEstimatorLoading(true);
            setShippingEstimatorStatus("Checking estimated freight options...", false);

            if (shippingEstimatorResults) {
                shippingEstimatorResults.hidden = true;
                shippingEstimatorResults.innerHTML = "";
            }

            try {
                var data = await estimateShippingForCart(postcode);
                renderShippingEstimatorResults(data);
            } catch (error) {
                console.error(error);
                setShippingEstimatorStatus(error.message || "We could not estimate freight right now. Please continue to checkout for final freight options.", true);
            } finally {
                setShippingEstimatorLoading(false);
            }
        });
    }

    root.addEventListener("click", function (event) {
        var minusButton = event.target.closest("[data-qty-minus]");
        if (minusButton) {
            var lineMinus = minusButton.getAttribute("data-line");
            var inputMinus = root.querySelector('[data-qty-input][data-line="' + lineMinus + '"]');
            var currentMinus = inputMinus ? parseInt(inputMinus.value, 10) || 1 : 1;

            if (currentMinus <= 1) return;

            updateQuantity(lineMinus, currentMinus - 1);
            return;
        }

        var plusButton = event.target.closest("[data-qty-plus]");
        if (plusButton) {
            var linePlus = plusButton.getAttribute("data-line");
            var inputPlus = root.querySelector('[data-qty-input][data-line="' + linePlus + '"]');
            var currentPlus = inputPlus ? parseInt(inputPlus.value, 10) || 1 : 1;

            var itemElPlus = plusButton.closest("[data-cart-item]");
            var maxQtyPlus = itemElPlus ? parseInt(itemElPlus.getAttribute("data-max-qty"), 10) : NaN;

            if (!Number.isNaN(maxQtyPlus) && currentPlus >= maxQtyPlus) return;

            updateQuantity(linePlus, currentPlus + 1);
            return;
        }

        var removeButton = event.target.closest("[data-remove-item]");
        if (removeButton) {
            updateQuantity(removeButton.getAttribute("data-line"), 0);
            return;
        }
    });

    root.addEventListener("input", function (event) {
        var qtyInput = event.target.closest("[data-qty-input]");
        if (!qtyInput) return;

        var line = qtyInput.getAttribute("data-line");
        var next = parseInt(qtyInput.value, 10);
        var itemEl = qtyInput.closest("[data-cart-item]");
        var maxQty = itemEl ? parseInt(itemEl.getAttribute("data-max-qty"), 10) : NaN;

        if (!Number.isFinite(next) || next < 1) next = 1;
        if (!Number.isNaN(maxQty) && next > maxQty) next = maxQty;

        qtyInput.value = next;
        syncLineQtyControls(line);
    });

    root.addEventListener("change", function (event) {
        var qtyInput = event.target.closest("[data-qty-input]");
        if (!qtyInput) return;

        var line = qtyInput.getAttribute("data-line");
        var next = parseInt(qtyInput.value, 10);
        var itemEl = qtyInput.closest("[data-cart-item]");
        var maxQty = itemEl ? parseInt(itemEl.getAttribute("data-max-qty"), 10) : NaN;

        if (!Number.isFinite(next) || next < 1) next = 1;
        if (!Number.isNaN(maxQty) && next > maxQty) next = maxQty;

        qtyInput.value = next;
        syncLineQtyControls(line);
        updateQuantity(line, next);
    });


    function buildTrackingPayload(eventType) {
        var customerName = shippingCustomerNameInput ? shippingCustomerNameInput.value.trim() : "";
        var postcode = lastShippingEstimatePostcode || validatePostcode(shippingPostcodeInput ? shippingPostcodeInput.value : "");
        var cart = lastKnownCart || {};

        return {
            event_type: eventType,
            source: "theme_cart",
            customer_name: customerName || null,
            destination: postcode ? { country: "AU", postal_code: postcode, name: customerName || null } : null,
            cart: cart,
            items: cart.items || [],
            cart_value_cents: cart.total_price || null,
            currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "AUD"
        };
    }

    function postTrackEvent(eventType) {
        var payload = buildTrackingPayload(eventType);
        var body = JSON.stringify(payload);
        try {
            var url = endpointWithShop(TRACK_ENDPOINT);
            if (navigator.sendBeacon) {
                navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
                return;
            }
            fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: body,
                keepalive: true
            }).catch(function () {});
        } catch (error) {}
    }

    root.addEventListener("click", function (event) {
        var checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
        if (!checkoutButton) return;
        postTrackEvent("cart_proceeded_to_checkout");
    }, true);

    setupStickyCheckout();

    refreshCartUI().catch(function (error) {
        console.error(error);
    });
})();
